import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Calls the supplied API to retrieve entity warnings whenever a load request is
 * dispatched.
 */
export const executeLoad = store.effects.create(
  <TTypeParams extends ec.models.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    feature.actions.load.request.observe().pipe(
      rxjs.switchMap(action =>
        plugin.api.get(action.data).pipe(
          rxjs.takeUntil(
            rxjs.merge(
              plugin.collection.feature.actions.changeContext.observe(),
              feature.actions.loadForCurrentEntity.request.observe(),
            ),
          ),
          rxjs.map(response =>
            feature.actions.load.success
              .from(action)
              .create({ request: action.data, response }),
          ),
          rxjs.catchError((error: Error) =>
            rxjs.of(
              feature.actions.load.error
                .from(action)
                .create({ error, request: action.data }),
            ),
          ),
        ),
      ),
    ),
)
